<template>
  <v-dialog
    v-model="open"
    persistent
    scrollable
    max-width="530px"
  >
    <v-card>
      <v-toolbar color="primary" dark class="pl-6">
        <div class="text-h6 text-center">
          Ordenação de Tipos de Ingresso
        </div>
      </v-toolbar>

      <v-card-text style="height: auto">
        <vue-draggable-next
          tag="div"
          :list="_section.ticket_types"
          class="list-group"
          handle=".handle"
          item-key="label"
        >
          <v-card
            v-for="item, j in _section.ticket_types"
            :key="j"
            class="mx-auto ma-3"
            elevation="2"
          >
            <div class="d-flex align-center justify-center ma-2 ml-3">
              <p class="flex-grow-1 font-weight-medium">
                {{ item.name }}
              </p>
              <v-icon
                class="handle"
                style="cursor: pointer"
                start
                color="grey-darken-1"
                icon="fa-regular fa-sort"
              />
            </div>
          </v-card>
        </vue-draggable-next>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red darken-1"
          variant="text"
          :disabled="loader.loading"
          @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          variant="text"
          :disabled="loader.loading"
          @click="submit"
        >
          Salvar
        </v-btn>
      </v-card-actions>
      <v-progress-linear v-show="loader.loading" indeterminate color="primary" />
    </v-card>
  </v-dialog>
</template>
<script lang="ts" setup>
import TicketTypeService from '@/services/TicketTypeService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import Section from '@/types/Section'
import { ref } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'

const loader = useLoader()
const snackbar = useSnackBar()

const emit = defineEmits([ 'close' ])

const { configurationId } = defineProps<{ configurationId: string }>()

const section = defineModel<Section>('section', { required: true })

const open = ref(true)

const _section = ref<Section>(JSON.parse(JSON.stringify(section.value)))

function cancel() {
  emit('close')
}

async function submit() {
  if (!_section.value.ticket_types?.length) return

  _section.value.ticket_types?.forEach((t, i) => {
    t.sorting_order = i
  })

  // It's creating a new configuration
  if (!configurationId) {
    section.value.ticket_types = _section.value.ticket_types
    emit('close')
    return
  }

  try {
    loader.increment()

    const typeIds = _section.value.ticket_types.map(t => t.id)

    await (new TicketTypeService()).updateSortingOrder(configurationId, typeIds)

    section.value.ticket_types = _section.value.ticket_types

    snackbar.show('Tipos de ingresso reordenados com sucesso!', 'success')

    emit('close')
  } finally {
    loader.decrement()
  }
}
</script>
